import { ContentLayout, Header } from "@amzn/awsui-components-react";
import { FC } from "react";
import Layout from "../../layout/Layout";

const StylesheetDiff: FC<any> = () => {
    return (
        <Layout>
            <ContentLayout header={<Header variant="h1">Stylesheet Diff</Header>}>
                <>Stylesheet Diff</>
            </ContentLayout>
            
        </Layout>
    )
}
export default StylesheetDiff;